import { useAppQuery } from '@/hooks/useAppQuery';
import { api } from '@/lib/api-client';
import type { GiftsFilters, ListGiftsResponse } from '@/models/gift';
import { type Pagination } from '@/models/pagination';

import { giftsQueryKey } from './queryKeys';

export const GIFTS_LIMIT = 25;

export const getGiftsQueryOptions = (
  filters?: GiftsFilters,
  pagination?: Omit<Pagination, 'total'>,
) => {
  return {
    queryKey: giftsQueryKey.filters(filters, pagination),
    queryFn: () => getGifts(filters, pagination),
  };
};

export const getGifts = async (
  filters?: GiftsFilters,
  pagination?: Omit<Pagination, 'total'>,
) => {
  const queryParams = new URLSearchParams();
  queryParams.append('sort_by', 'available_at');
  queryParams.append('sort_order', 'desc');

  if (pagination) {
    queryParams.append('limit', pagination.limit.toString());
    queryParams.append('offset', pagination.offset.toString());
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value === '' || value === 'all' || value == null) return;
      queryParams.append(key, value as string);
    });
  }

  const response = await api.get<ListGiftsResponse>(
    `/v1/gifts?${queryParams.toString()}`,
  );
  return response.data;
};

export const useGifts = (
  filters?: GiftsFilters,
  pagination?: Omit<Pagination, 'total'>,
) => useAppQuery(getGiftsQueryOptions(filters, pagination));
